import { ERD, SettingsActions } from "@dots-crm/contracts/client";
import { api } from "api";
import { QueryArgsNew } from "api/api.type";
import {
  SETTINGS_ENDPOINTS_URLS,
  SETTINGS_TAGS,
} from "./api-settings.constant";

export const { useReadPaymentSettingsQuery, useUpdatePaymentSettingsMutation } =
  api.injectEndpoints({
    endpoints: (builder) => ({
      readPaymentSettings: builder.query<
        ERD<SettingsActions["readPaymentSettings"]>,
        void
      >({
        query: () => ({
          url: SETTINGS_ENDPOINTS_URLS.readPaymentSettings,
          method: "get",
        }),
        providesTags: [SETTINGS_TAGS.settings],
      }),
      updatePaymentSettings: builder.mutation<
        SettingsActions["updatePaymentSettings"]["response"]["ok"],
        QueryArgsNew<SettingsActions["updatePaymentSettings"]>
      >({
        query: ({ payload }) => ({
          url: SETTINGS_ENDPOINTS_URLS.updatePaymentSettings,
          method: "put",
          payload,
        }),
        invalidatesTags: [SETTINGS_TAGS.settings],
      }),
    }),
  });
